export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'b8f018e3-3768-4739-a5ce-6320514bd223';
export const MODAL_CLOSE_SEC = 2.5;